import React, { createContext, useState } from 'react';

import OfficialPositionTypeData from './OfficialPositionTypeData';

export const OfficialPositionTypeStateContext = createContext();

const OfficialPositionTypeContextProvider = ({ children }) => {
  const stateHook = useState(OfficialPositionTypeData.INITIAL_STATE);

  return (
    <OfficialPositionTypeStateContext.Provider value={stateHook}>
      {children}
    </OfficialPositionTypeStateContext.Provider>
  );
};

export default OfficialPositionTypeContextProvider;